import styled from 'styled-components';

export const Container = styled.section`
  position: relative;

  width: 100%;
  height: 100vh;
`;

export const Wave = styled.svg`
  position: absolute;
  bottom: 0px;
`;
